import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import SearchableSelect from '../components/SearchableSelect';

interface Pet {
  id: string;
  unit_id: string;
  building: string | null;
  unit_number: string | null;
  name: string;
  species: string;
  breed: string;
  color: string;
  note: string;
}

// Хамгийн түгээмэл тэжээвэр амьтны төрлүүд.
const SPECIES = ['Нохой', 'Муур', 'Шувуу', 'Загас', 'Туулай', 'Хулгана', 'Мэрэгч', 'Яст мэлхий', 'Гүрвэл', 'Мэлхий'];
const OTHER = '__other__';

const emptyForm = { unit_id: '', name: '', species: '', breed: '', color: '', note: '' };

export default function PetsPage() {
  const [pets, setPets] = useState<Pet[]>([]);
  const [units, setUnits] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState<any>(emptyForm);
  const [speciesSel, setSpeciesSel] = useState(''); // dropdown сонголт
  const [editId, setEditId] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [unitFilter, setUnitFilter] = useState('');

  const load = () => {
    setLoading(true);
    const qs = unitFilter ? `?unit_id=${unitFilter}` : '';
    api.get(`/admin/pets${qs}`)
      .then(res => setPets(res?.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [unitFilter]);
  useEffect(() => { api.get('/admin/units?limit=1000').then(res => setUnits(res?.items || [])).catch(() => {}); }, []);

  const openNew = () => {
    setEditId(null); setForm(emptyForm); setSpeciesSel(''); setShowForm(true);
  };
  const openEdit = (p: Pet) => {
    setEditId(p.id);
    setForm({ unit_id: p.unit_id, name: p.name, species: p.species, breed: p.breed, color: p.color, note: p.note });
    setSpeciesSel(SPECIES.includes(p.species) ? p.species : (p.species ? OTHER : ''));
    setShowForm(true);
  };

  const onSpeciesChange = (val: string) => {
    setSpeciesSel(val);
    if (val === OTHER) setForm((f: any) => ({ ...f, species: '' }));
    else setForm((f: any) => ({ ...f, species: val }));
  };

  const handleSubmit = async (ev: React.FormEvent) => {
    ev.preventDefault();
    if (!form.unit_id) { alert('Орон сууц сонгоно уу'); return; }
    if (!form.species.trim()) { alert('Амьтны төрөл оруулна уу'); return; }
    setSaving(true);
    try {
      if (editId) await api.put(`/admin/pets/${editId}`, form);
      else await api.post('/admin/pets', form);
      setShowForm(false); setForm(emptyForm); setEditId(null);
      load();
    } catch (e: any) {
      alert(e?.body ? (JSON.parse(e.body)?.detail || 'Алдаа') : 'Алдаа гарлаа');
    } finally { setSaving(false); }
  };

  const handleDelete = async (p: Pet) => {
    if (!window.confirm(`${p.species}${p.name ? ` "${p.name}"` : ''}-г устгах уу?`)) return;
    await api.delete(`/admin/pets/${p.id}`);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', margin: 0 }}>Тэжээвэр амьтан</h2>
          <p style={{ color: '#5f6f66', fontSize: 13, margin: '4px 0 0' }}>Орон сууц бүрт бүртгэлтэй тэжээвэр амьтдын мэдээлэл</p>
        </div>
        <button onClick={openNew} style={btnPrimary}>+ Амьтан бүртгэх</button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <select value={unitFilter} onChange={e => setUnitFilter(e.target.value)} style={{ ...inputStyle, maxWidth: 220 }}>
          <option value="">Бүх орон сууц</option>
          {units.map((u: any) => <option key={u.id} value={u.id}>{u.building} - {u.unit_number}</option>)}
        </select>
      </div>

      {loading ? <p>Уншиж байна...</p> : (
        <div style={card}>
          {pets.length === 0 ? (
            <p style={{ color: '#5f6f66', textAlign: 'center', padding: 24 }}>Одоогоор тэжээвэр амьтан бүртгээгүй байна.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>Орон сууц</th>
                  <th style={th}>Төрөл</th>
                  <th style={th}>Нэр</th>
                  <th style={th}>Үүлдэр</th>
                  <th style={th}>Өнгө</th>
                  <th style={th}>Тэмдэглэл</th>
                  <th style={th}></th>
                </tr>
              </thead>
              <tbody>
                {pets.map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}><strong>{p.building} - {p.unit_number}</strong></td>
                    <td style={td}>{p.species}</td>
                    <td style={td}>{p.name || '-'}</td>
                    <td style={td}>{p.breed || '-'}</td>
                    <td style={td}>{p.color || '-'}</td>
                    <td style={{ ...td, color: '#5f6f66' }}>{p.note || '-'}</td>
                    <td style={td}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => openEdit(p)} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 13 }}>Засах</button>
                        <button onClick={() => handleDelete(p)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 13 }}>Устгах</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ ...card, width: 500, maxWidth: '92%' }} onClick={ev => ev.stopPropagation()}>
            <h3 style={{ margin: '0 0 16px', fontWeight: 700, color: '#1c2b22' }}>{editId ? 'Амьтан засах' : 'Тэжээвэр амьтан бүртгэх'}</h3>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={labelStyle}>Орон сууц *</label>
                <SearchableSelect
                  options={units.map((u: any) => ({ value: u.id, label: `${u.building} - ${u.unit_number}` }))}
                  value={form.unit_id}
                  onChange={v => setForm({ ...form, unit_id: v })}
                  placeholder="Хайх: блок эсвэл тоот"
                  allowClear={false}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={labelStyle}>Төрөл *</label>
                  <select value={speciesSel} onChange={e => onSpeciesChange(e.target.value)} style={inputStyle} required>
                    <option value="">-- Сонгох --</option>
                    {SPECIES.map(s => <option key={s} value={s}>{s}</option>)}
                    <option value={OTHER}>Бусад (гараар)</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Нэр</label>
                  <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inputStyle} placeholder="Бобик" />
                </div>
              </div>
              {speciesSel === OTHER && (
                <div>
                  <label style={labelStyle}>Төрлийг гараар бичих *</label>
                  <input value={form.species} onChange={e => setForm({ ...form, species: e.target.value })} style={inputStyle} placeholder="Жишээ: Хэрэм" autoFocus />
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={labelStyle}>Үүлдэр</label>
                  <input value={form.breed} onChange={e => setForm({ ...form, breed: e.target.value })} style={inputStyle} placeholder="Немецкая овчарка" />
                </div>
                <div>
                  <label style={labelStyle}>Өнгө</label>
                  <input value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} style={inputStyle} placeholder="Хар бор" />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Тэмдэглэл</label>
                <input value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} style={inputStyle} placeholder="Вакцинжуулсан, тэмдэг г.м." />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button type="submit" disabled={saving} style={{ ...btnPrimary, opacity: saving ? 0.7 : 1 }}>{saving ? 'Хадгалж байна...' : 'Хадгалах'}</button>
                <button type="button" onClick={() => setShowForm(false)} style={{ background: '#e8e5dc', color: '#2a3b32', border: 'none', padding: '8px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Болих</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = { background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'" };
const card: React.CSSProperties = { background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16 };
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = { width: '100%', padding: '10px 14px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6' };
